<template>
    <div class="page-header">
      <div class="flex gap-2 align-center items-center">
        <abbr v-if="back" class="cursor-pointer mr-3" @click="goback">
          <img src="@/assets/images/icons/back-icon.svg" alt="Attach Image">
        </abbr>
        <h3>{{ title }}</h3>
      </div>
      <div>
        <small>{{ breadcrumb }}</small>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: String,
      breadcrumb: String,
      back: Object,
    },
    methods: {
        goback(){
            this.$router.go(-1)
        }
    },
  };
  </script>
  
  <style scoped>
  .page-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  h3 {
    color: #10233e;
    font-size: 1.2rem;
    font-weight: 600;
  }
  small {
    color: #a5adb7;
  }
  </style>
  